import vue from 'vue';
import request from '../request';

export default {
  namespaced: true,
  state: {
    loading: false,
    loaded: false,
    single: {
      id: null,
      IBAN: null,
      BIC: null,
      status: '',
    },
    list: {},
    errors: {},
  },
  mutations: {
    setFormValue(state, payload) {
      Object.assign(state.single, payload);
    },
    setLoading(state, isLoading) {
      Object.assign(state, { loading: isLoading });
    },
    setSingle(state, payload) {
      Object.assign(state.single, payload);
    },
    setErrors(state, errors) {
      vue.set(state, 'errors', errors);
    },
  },
  actions: {
    setFormValue(context, payload) {
      context.commit('setFormValue', payload);
    },
    get(context, username) {
      return new Promise((resolve, reject) => {
        context.commit('setLoading', true);

        request.make({
          type: 'GET',
          url: `${process.env.API_URL}bank_account/${username}`,
        }, (err, res) => {
          if (err) {
            context.commit('setSingle', { IBAN: null, BIC: null });
            reject();
          }
          context.commit('setSingle', res.body.data);
          context.commit('setLoading', false);
          resolve();
        });
      });
    },
    update(context, payload) {
      return new Promise((resolve, reject) => {
        context.dispatch('setShowAllValidationErrors', false, { root: true });
        context.commit('setLoading', true);
        request.make({
          type: 'PUT',
          url: `${process.env.API_URL}bank_account/${payload.id}`,
          data: payload,
        }, (err, res) => {
          if (res.status === 422) {
            context.dispatch('setShowAllValidationErrors', true, { root: true });
            context.commit('setErrors', res.body.errors);
            reject();
          } else {
            context.commit('setErrors', []);
          }
          if (res.status === 200) {
            context.commit('setSingle', res.body.data);
            resolve();
          }
        });
      });
    },
    save(context, payload) {
      return new Promise((resolve, reject) => {
        context.dispatch('setShowAllValidationErrors', false, { root: true });
        context.commit('setLoading', true);
        request.make({
          type: 'POST',
          url: `${process.env.API_URL}bank_account`,
          data: payload,
        }, (err, res) => {
          if (res.status === 422) {
            context.dispatch('setShowAllValidationErrors', true, { root: true });
            context.commit('setErrors', res.body.errors);
            reject();
          } else {
            context.commit('setErrors', []);
          }
          if (res.status === 200) {
            context.commit('setSingle', res.body.data);
            resolve();
          }
        });
      });
    },
  },

};



// WEBPACK FOOTER //
// ./src/store/bankAccount.js